/* eslint-disable */
import { produce } from "immer";
import {
  FEEDBACK_FETCH_START,
  FEEDBACK_FETCH_SUCCESS,
  FEEDBACK_FETCH_FAILURE,
} from "../actions/types";

const feedbackReducer = (
  state = {
    fetching: false,
    data: [],
    error: null,
  },
  action,
) => {
  switch (action.type) {
    case FEEDBACK_FETCH_START:
      return produce(state, (draft) => {
        draft.fetching = true;
      });
    case FEEDBACK_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.fetching = true;
        draft.data = action.data;
        draft.fetching = false;
      });
    case FEEDBACK_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.fetching = false;
        draft.error = action.error;
      });
    default:
      return state;
  }
};

export default feedbackReducer;
